var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.content),function(element,index){return _c(_vm.getElementComponent(element),{key:`content_element_${index}`,tag:"component",attrs:{"data":element}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }